<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>local_shipping</mat-icon></div>
          <mat-card-title>Fornecedores</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          (tipoFiltroChange)="onFiltroChange()"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros (opcional) e clique em <strong>Consultar</strong>.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="fornecedores" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.id }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome Fantasia</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.nomeFantasia }}</td>
            </ng-container>
            <ng-container matColumnDef="telephone">
              <th mat-header-cell *matHeaderCellDef>Telefone</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.telephone }}</td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef>Endereço</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.address }}</td>
            </ng-container>
            <ng-container matColumnDef="block">
              <th mat-header-cell *matHeaderCellDef>Quadra</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.block }}</td>
            </ng-container>
            <ng-container matColumnDef="batch">
              <th mat-header-cell *matHeaderCellDef>Lote</th>
              <td mat-cell *matCellDef="let fornecedor">{{ fornecedor.batch }}</td>
            </ng-container>
            <ng-container matColumnDef="excluir">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let fornecedor" (click)="$event.stopPropagation()">
                <button (click)="openDialog(fornecedor.id)" mat-icon-button color="warn" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let fornecedor" (click)="$event.stopPropagation()">
                <button (click)="editar(fornecedor.id)" mat-icon-button color="accent" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>
          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)"></mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
